import { deliveryNote as deliveryNoteEn } from '../en/deliveryNote';

export const deliveryNote = {
  ...deliveryNoteEn,
  deliveryNotes: 'බෙදාහැරීමේ සටහන්',
  allDeliveryNotes: 'සියලුම බෙදාහැරීමේ සටහන්',
  createDeliveryNote: 'බෙදාහැරීමේ සටහනක් සාදන්න',
  deliveryNoteDetails: 'බෙදාහැරීමේ සටහනේ විස්තර',
  status_pending: 'පොරොත්තුවෙන්',
  status_delivered: 'බෙදාහරින ලදී',
  status_cancelled: 'අවලංගු කරන ලදී',
  officialDeliveryNote: 'නිල බෙදාහැරීම් සටහන',
  shop: 'සාප්පුව',
  allShops: 'සියලුම සාප්පු',
  orderNotFound: 'ඇණවුම හමු නොවීය',
  remainingQty: 'ඉතිරි ප්‍රමාණය',
};
